module.exports = __webpack_public_path__ + "img/NeTI.6e6bfcec.jpg";